<template>
  <div id="app">
    <div class="particle-bg">
      <!-- 动态粒子由Login/Register页面JS生成 -->
    </div>
    <transition name="fade-slide" mode="out-in">
      <router-view />
    </transition>
    <FloatToolbar />
  </div>
</template>

<script>
import FloatToolbar from './components/FloatToolbar.vue'

export default {
  name: 'App',
  components: { FloatToolbar }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Opera */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  position: relative;
}
@import url('./assets/modern-bg.css');

.fade-slide-enter-active, .fade-slide-leave-active {
  transition: opacity 0.35s cubic-bezier(.4,0,.2,1);
}
.fade-slide-enter-from, .fade-slide-leave-to {
  opacity: 0;
}
.fade-slide-enter-to, .fade-slide-leave-from {
  opacity: 1;
}
</style>